import React from 'react';
import Reveal from './Reveal';
import './Music.css';

const songs = [
  { id: 1, title: '6 de Janeiro', youtubeId: 'drg-r9JZq5A', url: 'https://www.youtube.com/watch?v=drg-r9JZq5A&list=PLxeNPdoj85lya1Y6HwQPvZOCZjski5ZbM&index=3' },
  { id: 2, title: 'Barraco de Zinco', youtubeId: 'UXJ1zn3r4Rs', url: 'https://www.youtube.com/watch?v=UXJ1zn3r4Rs&list=PLxeNPdoj85lya1Y6HwQPvZOCZjski5ZbM&index=4' },
  { id: 3, title: 'Pagode do Mané', youtubeId: 'dFpHl5nYQ0o', url: 'https://www.youtube.com/watch?v=dFpHl5nYQ0o&list=PLxeNPdoj85lya1Y6HwQPvZOCZjski5ZbM&index=5' },
  { id: 4, title: 'Rio de Janeiro Cidade Maravilhosa', youtubeId: 'tdNHXY0Tc-c', url: 'https://www.youtube.com/watch?v=tdNHXY0Tc-c&list=PLxeNPdoj85lya1Y6HwQPvZOCZjski5ZbM&index=6' }
];

export const PALCO_MP3_URL = 'https://www.palcomp3.com.br/varellasambista/';

// As 10 faixas publicadas no Palco MP3 (perfil oficial do artista).
const tracks = [
  { title: 'Forró da Bicharada', slug: 'forro-da-bicharada', featured: true },
  { title: 'Sabiá Laranjeira', slug: 'sabia-laranjeira', featured: true },
  { title: 'Rio de Janeiro Cidade Maravilhosa', slug: 'rio-de-janeiro-cidade-maravilhosa' },
  { title: 'Barraco de Zinco', slug: 'barraco-de-zinco' },
  { title: 'A Malandragem', slug: 'a-malandragem' },
  { title: 'Brasil Sempre Brasil', slug: 'brasil-sempre-brasil' },
  { title: 'É de Você que Eu Gosto Mais', slug: 'e-de-voce-que-eu-gosto-mais' },
  { title: 'Biscoito', slug: 'biscoito' },
  { title: 'Tempero da Nega', slug: 'tempero-da-nega' },
  { title: 'Pagode do Mané', slug: 'pagode-do-mane' }
];

// Links de streaming. Substitua os href "#" pelas URLs reais dos perfis do artista.
const streaming = [
  {
    name: 'YouTube',
    label: 'Playlist completa',
    url: 'https://www.youtube.com/playlist?list=PLxeNPdoj85lya1Y6HwQPvZOCZjski5ZbM',
    color: '#FF0000'
  },
  { name: 'Palco MP3', label: '10 músicas', url: PALCO_MP3_URL, color: '#00A859' },
  // TODO: inserir URL real do Spotify
  { name: 'Spotify', label: 'Ouvir', url: '#', color: '#1DB954' },
  // TODO: inserir URL real do Deezer
  { name: 'Deezer', label: 'Ouvir', url: '#', color: '#A238FF' }
];

const NoteIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
    <path d="M9 18V5l12-2v13" />
  </svg>
);

const PlaySmall = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M8 5.14v13.72a1 1 0 0 0 1.54.84l10.3-6.86a1 1 0 0 0 0-1.68L9.54 4.3A1 1 0 0 0 8 5.14Z" />
  </svg>
);

const Music = () => {
  return (
    <section id="music" className="music section">
      <div className="container">
        <Reveal>
          <span className="section-eyebrow">Samba de raiz &amp; samba-enredo</span>
          <h2 className="section-title">Música &amp; Vídeos</h2>
          <p className="section-subtitle">
            Composições que nasceram na boêmia da Lapa e carregam a essência da
            música popular brasileira. Reconhecido pelo Sindicato Nacional dos Compositores.
          </p>
        </Reveal>

        <div className="music-grid">
          {songs.map((song, index) => (
            <Reveal key={song.id} className="music-item" delay={(index % 2) * 90}>
              <div className="video-container">
                <iframe
                  src={`https://www.youtube.com/embed/${song.youtubeId}`}
                  title={song.title}
                  frameBorder="0"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="youtube-video"
                ></iframe>
              </div>
              <div className="music-info">
                <h3 className="music-title">{song.title}</h3>
                <a href={song.url} target="_blank" rel="noopener noreferrer" className="youtube-link">
                  Assistir no YouTube →
                </a>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="tracks-block">
          <div className="tracks-header">
            <h3 className="tracks-title">Ouça no Palco MP3</h3>
            <a href={PALCO_MP3_URL} target="_blank" rel="noopener noreferrer" className="tracks-all">
              Ver o perfil completo →
            </a>
          </div>
          <ol className="tracks-list">
            {tracks.map((t, i) => (
              <li key={t.slug}>
                <a
                  href={`${PALCO_MP3_URL}${t.slug}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="track-link"
                  aria-label={`Ouvir ${t.title} no Palco MP3`}
                >
                  <span className="track-index">{String(i + 1).padStart(2, '0')}</span>
                  <span className="track-name">{t.title}</span>
                  {t.featured && <span className="track-badge">Destaque</span>}
                  <span className="track-play"><PlaySmall /></span>
                </a>
              </li>
            ))}
          </ol>
        </Reveal>

        <Reveal className="streaming-bar">
          <h3 className="streaming-title">Ouça em todas as plataformas</h3>
          <div className="streaming-links">
            {streaming.map((s) => {
              const disabled = s.url === '#';
              return (
                <a
                  key={s.name}
                  href={s.url}
                  target={disabled ? undefined : '_blank'}
                  rel="noopener noreferrer"
                  className={`streaming-link ${disabled ? 'is-soon' : ''}`}
                  style={{ '--brand': s.color }}
                  aria-disabled={disabled}
                  onClick={(e) => disabled && e.preventDefault()}
                >
                  <NoteIcon />
                  <span className="streaming-name">{s.name}</span>
                  <span className="streaming-label">{disabled ? 'em breve' : s.label}</span>
                </a>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Music;
